/**
 * Global configuration settings for the admin dashboard
 */

// Environment detection
export const IS_DEVELOPMENT = import.meta.env.DEV;
export const IS_PRODUCTION = import.meta.env.PROD;

// API configuration
export const API_BASE_URL = import.meta.env.VITE_API_URL || import.meta.env.VITE_API_BASE_URL || '/api/v1';
export const IS_DOCKER = import.meta.env.VITE_DOCKER === 'true' || API_BASE_URL.includes('backend:');
export const API_TIMEOUT = 60000; // 60 seconds

// Image configuration
export const IMAGE_BASE_URL = ''; // Always use relative paths for images
export const IMAGE_PATHS = {
  PRODUCTS: '/images/products',
  DEFAULT: '/images'
};

// WebSocket configuration
const getWsBaseUrl = () => {
  if (import.meta.env.VITE_WS_URL) return import.meta.env.VITE_WS_URL;

  // Dynamic derivation from API_BASE_URL if no explicit socket URL provided
  try {
    const api_url = new URL(API_BASE_URL, window.location.origin);
    return `${api_url.protocol === 'https:' ? 'wss:' : 'ws:'}//${api_url.host}`;
  } catch (e) {
    return `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}`;
  }
};

export const WS_BASE_URL = getWsBaseUrl();
export const WS_RECONNECT_DELAY = 1000; // 1 second
export const WS_MAX_RECONNECT_ATTEMPTS = 5;

// Authentication configuration
export const AUTH_TOKEN_KEY = 'admin_token';
export const AUTH_USER_KEY = 'admin_user';
export const AUTH_REFRESH_TOKEN_KEY = 'refresh_token';
export const AUTH_EXPIRY_KEY = 'auth_expiry';

// UI configuration
export const PAGE_SIZE = 10;
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const SUPPORTED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

// Development configuration
export const DEV_CONFIG = {
  enableDebugLogging: IS_DEVELOPMENT,
  useMockDataFallback: IS_DEVELOPMENT,
  auth: {
    defaultAdminEmail: 'admin@example.com',
    defaultAdminPassword: 'admin123'
  }
};
